<template>
  <el-container class="ASelectColumnForm">
    <el-main class="p-0">
      <el-form :model="data" ref="form" label-width="100px">
        <el-checkbox 
          :indeterminate="isIndeterminate" 
          v-model="checkAll" 
          @change="handleCheckAllChange"
        >All</el-checkbox>
        <div style="margin-top: 10px;"></div>
        <div class="select-columns">
          <el-checkbox-group 
            label-width="100px"
            v-model="checkedColumns" 
            @change="handleCheckedColumns">
            <el-checkbox            
              v-for="column in data.columns"
              :disabled="(!data.fixed_columns.find(item => item.key === column.key)) ? false : true"
              :label="column.key"
              :key="column.key"
            >{{column.value}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-top: 15px;"></div>
      </el-form>
    </el-main>
    <el-footer height="40px">
      <el-button
        type="primary"
        v-shortkey="['f4']"        
        @shortkey.native="clickCompleted"
        @click="clickCompleted"
      >완료 (F4)</el-button>
      <el-button 
        class="close-button" 
        @click="closeDialog"
      >닫기 (ESC)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";

export default {
  name: "ASelectColumnForm",
  mixins: [ form ],  
  data() {
    return {
      checkAll: false,
      checkedColumns: [],
      isIndeterminate: true,
    }
  },
  props: {
    data: {
      type: Object,
      required: true,      
    },
  },
  mounted() {
    this.checkedColumns = this.data.selected_columns;
    // this.data.fixed_columns.forEach(item => {
    //   if (!this.checkedColumns.find( findItem => findItem === item.key)) {
    //     this.checkedColumns.push(item.key);
    //   }
    // });
  },
  methods: {
    clickCompleted() {
      this.$emit("completed", this.checkedColumns);
    },
    handleCheckAllChange(value) {      
      this.checkedColumns = value ? this.data.columns.map(item => item.key) : this.data.fixed_columns.map(item => item.key);
      this.data.selected_columns = this.checkedColumns;
      this.isIndeterminate = false;      
    },
    handleCheckedColumns(value) {            
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.data.columns.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.columns.length;
    },
  },
}
</script>